namespace GeniuzPOS.ReportMasterData {
    export class Report_1501Columns {
        static columnsKey = 'ReportMasterData.Report_1501';
    }
}
